<template>
  <div class="contactotk">
    <ContactoTK />
  </div>
</template>

<script>
import ContactoTK from '@/components/ContactoTK.vue'

export default {
  name: 'contacto',
  components: {
    ContactoTK
  }
}
</script>
